var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29713 3.01343L4.77673 6.6923L15.282 6.74305C15.4427 6.74368 15.6018 6.77782 15.75 6.84353C15.8983 6.90923 16.0328 7.0052 16.1459 7.12595C16.2591 7.2467 16.3486 7.38985 16.4093 7.54721C16.4701 7.70458 16.5009 7.87307 16.5 8.04303C16.4992 8.2129 16.4668 8.38095 16.4046 8.53757C16.3424 8.69419 16.2516 8.83631 16.1375 8.9558C16.0233 9.0753 15.8879 9.16983 15.7392 9.23399C15.5904 9.29815 15.4312 9.33069 15.2705 9.32973L4.76759 9.2802L8.24115 12.9965C8.35436 13.1171 8.444 13.26 8.50493 13.4172C8.56587 13.5744 8.5969 13.7427 8.59627 13.9126C8.59563 14.0825 8.56333 14.2506 8.50122 14.4072C8.43911 14.5639 8.3484 14.7061 8.23429 14.8257C8.00357 15.0671 7.69167 15.2018 7.3671 15.2002C7.04253 15.1986 6.73183 15.0609 6.50322 14.8172L0.790141 8.71719C0.602876 8.51692 0.498515 8.24619 0.500015 7.96456C0.501515 7.68294 0.608753 7.41347 0.798139 7.21544L6.57178 1.1746C6.80231 0.933288 7.11402 0.798626 7.4384 0.800211C7.76278 0.801797 8.0733 0.939501 8.3017 1.18306C8.41511 1.30354 8.50494 1.44646 8.56609 1.60366C8.62723 1.76087 8.65849 1.92927 8.65806 2.09925C8.65764 2.26922 8.62554 2.43745 8.56362 2.59431C8.50169 2.75117 8.41113 2.89359 8.29713 3.01343Z",
    fill: "#10523E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.d6f3239db13cfb93edb1e11231c375d5.svg";
export { ForwardRef as ReactComponent };